import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.scss';

export type PaginationType = {
  totalCount?: number;
  page?: number;
  totalPage?: number;
  totalPages?: number;
  hasNextPage?: boolean;
  nextPage?: number;
};

export default function Pagination({
  setPage,
  paginationData,
  getPath,
}: {
  setPage?: (page: number) => void;
  paginationData: PaginationType;
  getPath: (page: number) => string;
}) {
  const { page, totalPages, hasNextPage, nextPage } = paginationData;
  const nextPages = [...Array(3)];
  return (
    <ul className={styles.pagination} data-test="pagination">
      {page > 1 && (
        <li className={styles.pageItem}>
          <a
            href={getPath(page - 1)}
            className={styles.pageLink}
            onClick={(e) => {
              if (typeof setPage !== 'undefined') {
                e.preventDefault();
                setPage(page - 1);
              }
            }}
          >
            Prev
          </a>
        </li>
      )}
      <li className={clsx(styles.pageItem, styles.currentPage, styles.pageLink)}>{page}</li>
      {nextPages.map((_, i) => {
        const index = page + i + 1;
        if (index > totalPages) return null;
        return (
          <li className={styles.pageItem} key={i}>
            <a
              href={getPath(index)}
              className={styles.pageLink}
              onClick={(e) => {
                if (typeof setPage !== 'undefined') {
                  e.preventDefault();
                  setPage(index);
                }
              }}
            >
              {index}
            </a>
          </li>
        );
      })}
      {hasNextPage && (
        <li className={styles.pageItem}>
          <a
            href={getPath(nextPage)}
            className={styles.pageLink}
            data-test="pagination-next"
            onClick={(e) => {
              if (typeof setPage !== 'undefined') {
                e.preventDefault();
                setPage(nextPage);
              }
            }}
          >
            Next
          </a>
        </li>
      )}
      {totalPages > page && (
        <li className={styles.pageItem}>
          <a
            href={getPath(totalPages)}
            className={styles.pageLink}
            onClick={(e) => {
              if (typeof setPage !== 'undefined') {
                e.preventDefault();
                setPage(totalPages);
              }
            }}
          >
            Last
          </a>
        </li>
      )}
    </ul>
  );
}
